import { apiSlice } from "@/services/api-slice";
import { Users, CreateUser, UpdateUser, UserSearch, UsersInfo } from "./users.interface";
import { APIResponse } from "@/types/custom-http";


export const usersApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
      // Obtener todos los usuarios
      getUsers: builder.query<APIResponse<Users[]>, void>({
        query: () => ({
          url: "auth/users"
        }),
        providesTags: ["User"],
      }),

      getUsersByAdmin: builder.query<APIResponse<Users[]>, void>({
        query: () => ({
          url: "auth/users/admin"
        }),
        providesTags: ["User"],
      }),

      getUsersInfo: builder.query<APIResponse<UsersInfo>, void>({
        query: () => ({
          url: "auth/users/info"
        }),
        providesTags: ["User"],
      }),

      
      // Obtener un usuario por ID
      getUserById: builder.query<APIResponse<Users>, string>({
        query: (id) => ({ url:`/users/${id}`}),
        providesTags: (_result, _error, id) => [{ type: 'User', id }],
      }),


      // Buscar Usuarios
      searchUsers: builder.query<APIResponse<UserSearch[]>, string>({
        query: (search) => ({
          url: `auth/users/search`,
          params: { search },
        }),
        providesTags: ["User"],
      }),
      
      // Crear un nuevo usuario
      createUser: builder.mutation<APIResponse<Users>, CreateUser>({
        query: (user) => ({
          url: 'auth/users',
          method: 'POST',
          body: user,
        }),
        invalidatesTags: ['User'],
      }),
      
      // Actualizar un usuario existente
      updateUser: builder.mutation<APIResponse<Users>, { id: string; changes: UpdateUser }>({
        query: ({ id, changes }) => ({
          url: `auth/users/${id}`,
          method: 'PATCH',
          body: changes,
        }),
        invalidatesTags: (_result, _error, { id }) => [{ type: 'User', id },'User'],
      }),

      changerPassword: builder.mutation<APIResponse<Users>, {id: string, password: string}>({
        query: ({id, password}) => ({
          url: `auth/users/password/${id}`,
          method: 'PATCH',
          body: {password}
        }),
        invalidatesTags: (_result, _error, { id }) => [{ type: 'User', id },'User'],
      }),
      
      // Eliminar un Usuario
      deleteUser: builder.mutation<APIResponse<null>, string>({
        query: (id) => ({
          url: `auth/users/${id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['User'],
      })

    }),
  });
  
  export const {
    useGetUsersQuery,
    useGetUsersByAdminQuery,
    useGetUsersInfoQuery,
    useGetUserByIdQuery,
    useSearchUsersQuery,
    useLazySearchUsersQuery,
    useCreateUserMutation,
    useUpdateUserMutation,
    useChangerPasswordMutation,
    useDeleteUserMutation
  } = usersApi;
